<template>
  <el-card shadow="never" class="aui-card--fill">
    <el-alert
      title="数字货币支付配置,请谨慎操作!"
      type="warning"
      :closable="false"
      show-icon
      style="margin-bottom: 20px;">
    </el-alert>
    <div class="mod-crypto__payconfig">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.showName" placeholder="请输入支付名称" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.isEnabled" placeholder="启用状态" clearable>
            <el-option label="启用" :value="1"></el-option>
            <el-option label="关闭" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('crypto:payconfig:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('crypto:payconfig:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="payName" label="支付名称" header-align="center" align="center"></el-table-column>
        <el-table-column prop="showName" label="显示名称" header-align="center" align="center"></el-table-column>
        <el-table-column prop="merchantsName" label="商户名称" header-align="center" align="center"></el-table-column>
        <el-table-column prop="status" label="启用状态" header-align="center" align="center" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status === 1" type="success">启用</el-tag>
            <el-tag v-if="scope.row.status === 2" type="danger">关闭</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="time" label="创建时间" header-align="center" align="center" width="180"></el-table-column>
        <el-table-column :label="$t('handle')" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('crypto:payconfig:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('crypto:payconfig:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="refreshDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './crypto-payconfig-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/crypto/payconfig/list',
        getDataListIsPage: true,
        deleteURL: '/crypto/payconfig',
        deleteIsBatch: true
      },
      dataForm: {
        payName: '',
        status: ''
      }
    }
  },
  components: {
    AddOrUpdate
  }
}
</script>
